import React from "react";
import ImgHeader from "../ImgHeader";
import { Container, Grid, Paper, Typography, Link } from "@material-ui/core";
import { withRouter, RouteComponentProps } from "react-router";
import styled from "styled-components";
import { H1, H2, H3 } from "../Headers";
import ISupportCall from "../../models/ISupportCall";
import getUrl from "../../functions/getUrl";

interface ISignUpConfirmation {
  serviceCall: ISupportCall;
}

const SubTitle = styled(H2)`
  margin-top: 0;
`;

const ThankYouPaper = styled(Paper)`
  margin: 3em 0;
  padding: 2em;
  text-align: center;
`;

const ThankYouParagraph = styled(Typography)`
  margin: 5px;
  padding: 5px;
`;

class SignUpConfirmation extends React.Component<RouteComponentProps, ISignUpConfirmation> {
  render() {
    var scNumber = this.props.location.state;

    if (!scNumber) {
      const urlParams = new URLSearchParams(this.props.location.search);
      let num = urlParams.get("scNumber");
      if (num && num !== "undefined") {
        scNumber = num;
      }
    }

    return (
      <>
        <ImgHeader
          url="/static/img/kelly-sikkema-fvpgfw3IF1w-unsplash.jpg"
          shadowOpacity={0.4}
          mediaBreakpoints={[
            {
              minWidth: 0,
              leftOffset: "0",
              topOffset: "0",
            },
            {
              minWidth: 760,
              leftOffset: "0",
              topOffset: "-100px",
            },
            {
              minWidth: 1100,
              leftOffset: "0",
              topOffset: "-200px",
            },
            {
              minWidth: 1350,
              leftOffset: "0",
              topOffset: "-300px",
            },
            {
              minWidth: 1550,
              leftOffset: "0",
              topOffset: "-400px",
            },
            {
              minWidth: 1740,
              leftOffset: "0",
              topOffset: "-500px",
            },
          ]}
        >
          <H1>We've Received Your Request!</H1>
        </ImgHeader>
        <Container>
          <Grid container direction="column" alignItems="center" spacing={3}>
            <Grid item>
              <ThankYouPaper>
                <SubTitle>Thank you for applying!</SubTitle>
                <ThankYouParagraph paragraph>We look forward to working with you!</ThankYouParagraph>
                <ThankYouParagraph paragraph>
                  Our staff will be reviewing your request shortly. Once your request has been approved you will receive an email with more instructions on how
                  to complete the application process and log into the Partner Portal.
                </ThankYouParagraph>
                <ThankYouParagraph paragraph>
                  While you wait, please be sure to review the <a href={getUrl("/partnership")}>Partnership</a> area. Find out how becoming a partner with
                  Skyward can benefit you and your customers!
                </ThankYouParagraph>
                <ThankYouParagraph paragraph>
                  For your reference, the number of your request is:
                  <H3># {scNumber}</H3>
                </ThankYouParagraph>
              </ThankYouPaper>
            </Grid>
          </Grid>
        </Container>
      </>
    );
  }
}
export default withRouter(SignUpConfirmation);
